var endpointMap = {
	ar: {
		core: "translation-ar.json",
		hmdFeedback: "translation-ar.json",
		homepage: "translation-ar.json",
		learningModule: "translation-ar.json",
		learningPathway: "translation-ar.json",
		navigation: "translation-ar.json",
		search: "translation-ar.json",
		topic: "translation-ar.json",
		webinar: "translation-ar.json"
	},
	"ar-AE": {
		core: "translation-ar.json",
		hmdFeedback: "translation-ar.json",
		homepage: "translation-ar.json",
		learningModule: "translation-ar.json",
		learningPathway: "translation-ar.json",
		navigation: "translation-ar.json",
		search: "translation-ar.json",
		topic: "translation-ar.json",
		webinar: "translation-ar.json"
	},
	bn: {
		core: "translation-bn.json",
		hmdFeedback: "translation-bn.json",
		homepage: "translation-bn.json",
		learningModule: "translation-bn.json",
		learningPathway: "translation-bn.json",
		navigation: "translation-bn.json",
		search: "translation-bn.json",
		topic: "translation-bn.json",
		webinar: "translation-bn.json"
	},
	"bn-IN": {
		core: "translation-bn.json",
		hmdFeedback: "translation-bn.json",
		homepage: "translation-bn.json",
		learningModule: "translation-bn.json",
		learningPathway: "translation-bn.json",
		navigation: "translation-bn.json",
		search: "translation-bn.json",
		topic: "translation-bn.json",
		webinar: "translation-bn.json"
	},
	de: {
		core: "translation-de.json",
		hmdFeedback: "translation-de.json",
		homepage: "translation-de.json",
		learningModule: "translation-de.json",
		learningPathway: "translation-de.json",
		navigation: "translation-de.json",
		search: "translation-de.json",
		topic: "translation-de.json",
		webinar: "translation-de.json"
	},
	"de-DE": {
		core: "translation-de.json",
		hmdFeedback: "translation-de.json",
		homepage: "translation-de.json",
		learningModule: "translation-de.json",
		learningPathway: "translation-de.json",
		navigation: "translation-de.json",
		search: "translation-de.json",
		topic: "translation-de.json",
		webinar: "translation-de.json"
	},
	en: {
		core: "translation-en.json",
		credential: "translation-en.json",
		hmdFeedback: "translation-en.json",
		homepage: "translation-en.json",
		learningModule: "translation-en.json",
		learningPathway: "translation-en.json",
		navigation: "translation-en.json",
		search: "translation-en.json",
		topic: "translation-en.json",
		webinar: "translation-en.json"
	},
	"en-AU": {
		core: "translation-en.json",
		hmdFeedback: "translation-en.json",
		homepage: "translation-en.json",
		learningModule: "translation-en.json",
		learningPathway: "translation-en.json",
		navigation: "translation-en.json",
		search: "translation-en.json",
		topic: "translation-en.json",
		webinar: "translation-en.json"
	},
	"en-CA": {
		core: "translation-en.json",
		hmdFeedback: "translation-en.json",
		homepage: "translation-en.json",
		learningModule: "translation-en.json",
		learningPathway: "translation-en.json",
		navigation: "translation-en.json",
		search: "translation-en.json",
		topic: "translation-en.json",
		webinar: "translation-en.json"
	},
	"en-GB": {
		core: "translation-en.json",
		hmdFeedback: "translation-en.json",
		homepage: "translation-en.json",
		learningModule: "translation-en.json",
		learningPathway: "translation-en.json",
		navigation: "translation-en.json",
		search: "translation-en.json",
		topic: "translation-en.json",
		webinar: "translation-en.json"
	},
	"en-IE": {
		core: "translation-en.json",
		hmdFeedback: "translation-en.json",
		homepage: "translation-en.json",
		learningModule: "translation-en.json",
		learningPathway: "translation-en.json",
		navigation: "translation-en.json",
		search: "translation-en.json",
		topic: "translation-en.json",
		webinar: "translation-en.json"
	},
	"en-IN": {
		core: "translation-en.json",
		hmdFeedback: "translation-en.json",
		homepage: "translation-en.json",
		learningModule: "translation-en.json",
		learningPathway: "translation-en.json",
		navigation: "translation-en.json",
		search: "translation-en.json",
		topic: "translation-en.json",
		webinar: "translation-en.json"
	},
	"en-SG": {
		core: "translation-en.json",
		hmdFeedback: "translation-en.json",
		homepage: "translation-en.json",
		learningModule: "translation-en.json",
		learningPathway: "translation-en.json",
		navigation: "translation-en.json",
		search: "translation-en.json",
		topic: "translation-en.json",
		webinar: "translation-en.json"
	},
	"en-US": {
		core: "translation-en.json",
		credential: "translation-en.json",
		hmdFeedback: "translation-en.json",
		homepage: "translation-en.json",
		learningModule: "translation-en.json",
		learningPathway: "translation-en.json",
		navigation: "translation-en.json",
		search: "translation-en.json",
		topic: "translation-en.json",
		webinar: "translation-en.json"
	},
	"en-ZA": {
		core: "translation-en.json",
		hmdFeedback: "translation-en.json",
		homepage: "translation-en.json",
		learningModule: "translation-en.json",
		learningPathway: "translation-en.json",
		navigation: "translation-en.json",
		search: "translation-en.json",
		topic: "translation-en.json",
		webinar: "translation-en.json"
	},
	es: {
		core: "translation-es.json",
		hmdFeedback: "translation-es.json",
		homepage: "translation-es.json",
		learningModule: "translation-es.json",
		learningPathway: "translation-es.json",
		navigation: "translation-es.json",
		search: "translation-es.json",
		topic: "translation-es.json",
		webinar: "translation-es.json"
	},
	"es-ES": {
		core: "translation-es.json",
		hmdFeedback: "translation-es.json",
		homepage: "translation-es.json",
		learningModule: "translation-es.json",
		learningPathway: "translation-es.json",
		navigation: "translation-es.json",
		search: "translation-es.json",
		topic: "translation-es.json",
		webinar: "translation-es.json"
	},
	"es-MX": {
		core: "translation-es.json",
		hmdFeedback: "translation-es.json",
		homepage: "translation-es.json",
		learningModule: "translation-es.json",
		learningPathway: "translation-es.json",
		navigation: "translation-es.json",
		search: "translation-es.json",
		topic: "translation-es.json",
		webinar: "translation-es.json"
	},
	fr: {
		core: "translation-fr.json",
		hmdFeedback: "translation-fr.json",
		homepage: "translation-fr.json",
		learningModule: "translation-fr.json",
		learningPathway: "translation-fr.json",
		navigation: "translation-fr.json",
		search: "translation-fr.json",
		topic: "translation-fr.json",
		webinar: "translation-fr.json"
	},
	"fr-BE": {
		core: "translation-fr.json",
		hmdFeedback: "translation-fr.json",
		homepage: "translation-fr.json",
		learningModule: "translation-fr.json",
		learningPathway: "translation-fr.json",
		navigation: "translation-fr.json",
		search: "translation-fr.json",
		topic: "translation-fr.json",
		webinar: "translation-fr.json"
	},
	"fr-FR": {
		core: "translation-fr.json",
		hmdFeedback: "translation-fr.json",
		homepage: "translation-fr.json",
		learningModule: "translation-fr.json",
		learningPathway: "translation-fr.json",
		navigation: "translation-fr.json",
		search: "translation-fr.json",
		topic: "translation-fr.json",
		webinar: "translation-fr.json"
	},
	gu: {
		core: "translation-gu.json",
		hmdFeedback: "translation-gu.json",
		homepage: "translation-gu.json",
		learningModule: "translation-gu.json",
		learningPathway: "translation-gu.json",
		navigation: "translation-gu.json",
		search: "translation-gu.json",
		topic: "translation-gu.json",
		webinar: "translation-gu.json"
	},
	"gu-IN": {
		core: "translation-gu.json",
		hmdFeedback: "translation-gu.json",
		homepage: "translation-gu.json",
		learningModule: "translation-gu.json",
		learningPathway: "translation-gu.json",
		navigation: "translation-gu.json",
		search: "translation-gu.json",
		topic: "translation-gu.json",
		webinar: "translation-gu.json"
	},
	hi: {
		core: "translation-hi.json",
		hmdFeedback: "translation-hi.json",
		homepage: "translation-hi.json",
		learningModule: "translation-hi.json",
		learningPathway: "translation-hi.json",
		navigation: "translation-hi.json",
		search: "translation-hi.json",
		topic: "translation-hi.json",
		webinar: "translation-hi.json"
	},
	"hi-IN": {
		core: "translation-hi.json",
		hmdFeedback: "translation-hi.json",
		homepage: "translation-hi.json",
		learningModule: "translation-hi.json",
		learningPathway: "translation-hi.json",
		navigation: "translation-hi.json",
		search: "translation-hi.json",
		topic: "translation-hi.json",
		webinar: "translation-hi.json"
	},
	it: {
		core: "translation-it.json",
		hmdFeedback: "translation-it.json",
		homepage: "translation-it.json",
		learningModule: "translation-it.json",
		learningPathway: "translation-it.json",
		navigation: "translation-it.json",
		search: "translation-it.json",
		topic: "translation-it.json",
		webinar: "translation-it.json"
	},
	"it-IT": {
		core: "translation-it.json",
		hmdFeedback: "translation-it.json",
		homepage: "translation-it.json",
		learningModule: "translation-it.json",
		learningPathway: "translation-it.json",
		navigation: "translation-it.json",
		search: "translation-it.json",
		topic: "translation-it.json",
		webinar: "translation-it.json"
	},
	ja: {
		core: "translation-ja.json",
		hmdFeedback: "translation-ja.json",
		homepage: "translation-ja.json",
		learningModule: "translation-ja.json",
		learningPathway: "translation-ja.json",
		navigation: "translation-ja.json",
		search: "translation-ja.json",
		topic: "translation-ja.json",
		webinar: "translation-ja.json"
	},
	"ja-JP": {
		core: "translation-ja.json",
		hmdFeedback: "translation-ja.json",
		homepage: "translation-ja.json",
		learningModule: "translation-ja.json",
		learningPathway: "translation-ja.json",
		navigation: "translation-ja.json",
		search: "translation-ja.json",
		topic: "translation-ja.json",
		webinar: "translation-ja.json"
	},
	kn: {
		core: "translation-kn.json",
		hmdFeedback: "translation-kn.json",
		homepage: "translation-kn.json",
		learningModule: "translation-kn.json",
		learningPathway: "translation-kn.json",
		navigation: "translation-kn.json",
		search: "translation-kn.json",
		topic: "translation-kn.json",
		webinar: "translation-kn.json"
	},
	"kn-IN": {
		core: "translation-kn.json",
		hmdFeedback: "translation-kn.json",
		homepage: "translation-kn.json",
		learningModule: "translation-kn.json",
		learningPathway: "translation-kn.json",
		navigation: "translation-kn.json",
		search: "translation-kn.json",
		topic: "translation-kn.json",
		webinar: "translation-kn.json"
	},
	ko: {
		core: "translation-ko.json",
		hmdFeedback: "translation-ko.json",
		homepage: "translation-ko.json",
		learningModule: "translation-ko.json",
		learningPathway: "translation-ko.json",
		navigation: "translation-ko.json",
		search: "translation-ko.json",
		topic: "translation-ko.json",
		webinar: "translation-ko.json"
	},
	"ko-KR": {
		core: "translation-ko.json",
		hmdFeedback: "translation-ko.json",
		homepage: "translation-ko.json",
		learningModule: "translation-ko.json",
		learningPathway: "translation-ko.json",
		navigation: "translation-ko.json",
		search: "translation-ko.json",
		topic: "translation-ko.json",
		webinar: "translation-ko.json"
	},
	ml: {
		core: "translation-ml.json",
		hmdFeedback: "translation-ml.json",
		homepage: "translation-ml.json",
		learningModule: "translation-ml.json",
		learningPathway: "translation-ml.json",
		navigation: "translation-ml.json",
		search: "translation-ml.json",
		topic: "translation-ml.json",
		webinar: "translation-ml.json"
	},
	"ml-IN": {
		core: "translation-ml.json",
		hmdFeedback: "translation-ml.json",
		homepage: "translation-ml.json",
		learningModule: "translation-ml.json",
		learningPathway: "translation-ml.json",
		navigation: "translation-ml.json",
		search: "translation-ml.json",
		topic: "translation-ml.json",
		webinar: "translation-ml.json"
	},
	mr: {
		core: "translation-mr.json",
		hmdFeedback: "translation-mr.json",
		homepage: "translation-mr.json",
		learningModule: "translation-mr.json",
		learningPathway: "translation-mr.json",
		navigation: "translation-mr.json",
		search: "translation-mr.json",
		topic: "translation-mr.json",
		webinar: "translation-mr.json"
	},
	"mr-IN": {
		core: "translation-mr.json",
		hmdFeedback: "translation-mr.json",
		homepage: "translation-mr.json",
		learningModule: "translation-mr.json",
		learningPathway: "translation-mr.json",
		navigation: "translation-mr.json",
		search: "translation-mr.json",
		topic: "translation-mr.json",
		webinar: "translation-mr.json"
	},
	nl: {
		core: "translation-nl.json",
		hmdFeedback: "translation-nl.json",
		homepage: "translation-nl.json",
		learningModule: "translation-nl.json",
		learningPathway: "translation-nl.json",
		navigation: "translation-nl.json",
		search: "translation-nl.json",
		topic: "translation-nl.json",
		webinar: "translation-nl.json"
	},
	"nl-BE": {
		core: "translation-nl.json",
		hmdFeedback: "translation-nl.json",
		homepage: "translation-nl.json",
		learningModule: "translation-nl.json",
		learningPathway: "translation-nl.json",
		navigation: "translation-nl.json",
		search: "translation-nl.json",
		topic: "translation-nl.json",
		webinar: "translation-nl.json"
	},
	"nl-NL": {
		core: "translation-nl.json",
		hmdFeedback: "translation-nl.json",
		homepage: "translation-nl.json",
		learningModule: "translation-nl.json",
		learningPathway: "translation-nl.json",
		navigation: "translation-nl.json",
		search: "translation-nl.json",
		topic: "translation-nl.json",
		webinar: "translation-nl.json"
	},
	pl: {
		core: "translation-pl.json",
		hmdFeedback: "translation-pl.json",
		homepage: "translation-pl.json",
		learningModule: "translation-pl.json",
		learningPathway: "translation-pl.json",
		navigation: "translation-pl.json",
		search: "translation-pl.json",
		topic: "translation-pl.json",
		webinar: "translation-pl.json"
	},
	"pl-PL": {
		core: "translation-pl.json",
		hmdFeedback: "translation-pl.json",
		homepage: "translation-pl.json",
		learningModule: "translation-pl.json",
		learningPathway: "translation-pl.json",
		navigation: "translation-pl.json",
		search: "translation-pl.json",
		topic: "translation-pl.json",
		webinar: "translation-pl.json"
	},
	pt: {
		core: "translation-pt.json",
		hmdFeedback: "translation-pt.json",
		homepage: "translation-pt.json",
		learningModule: "translation-pt.json",
		learningPathway: "translation-pt.json",
		navigation: "translation-pt.json",
		search: "translation-pt.json",
		topic: "translation-pt.json",
		webinar: "translation-pt.json"
	},
	"pt-BR": {
		core: "translation-pt.json",
		hmdFeedback: "translation-pt.json",
		homepage: "translation-pt.json",
		learningModule: "translation-pt.json",
		learningPathway: "translation-pt.json",
		navigation: "translation-pt.json",
		search: "translation-pt.json",
		topic: "translation-pt.json",
		webinar: "translation-pt.json"
	},
	"pt-PT": {
		core: "translation-pt.json",
		hmdFeedback: "translation-pt.json",
		homepage: "translation-pt.json",
		learningModule: "translation-pt.json",
		learningPathway: "translation-pt.json",
		navigation: "translation-pt.json",
		search: "translation-pt.json",
		topic: "translation-pt.json",
		webinar: "translation-pt.json"
	},
	sv: {
		core: "translation-sv.json",
		hmdFeedback: "translation-sv.json",
		homepage: "translation-sv.json",
		learningModule: "translation-sv.json",
		learningPathway: "translation-sv.json",
		navigation: "translation-sv.json",
		search: "translation-sv.json",
		topic: "translation-sv.json",
		webinar: "translation-sv.json"
	},
	"sv-SE": {
		core: "translation-sv.json",
		hmdFeedback: "translation-sv.json",
		homepage: "translation-sv.json",
		learningModule: "translation-sv.json",
		learningPathway: "translation-sv.json",
		navigation: "translation-sv.json",
		search: "translation-sv.json",
		topic: "translation-sv.json",
		webinar: "translation-sv.json"
	},
	ta: {
		core: "translation-ta.json",
		hmdFeedback: "translation-ta.json",
		homepage: "translation-ta.json",
		learningModule: "translation-ta.json",
		learningPathway: "translation-ta.json",
		navigation: "translation-ta.json",
		search: "translation-ta.json",
		topic: "translation-ta.json",
		webinar: "translation-ta.json"
	},
	"ta-IN": {
		core: "translation-ta.json",
		hmdFeedback: "translation-ta.json",
		homepage: "translation-ta.json",
		learningModule: "translation-ta.json",
		learningPathway: "translation-ta.json",
		navigation: "translation-ta.json",
		search: "translation-ta.json",
		topic: "translation-ta.json",
		webinar: "translation-ta.json"
	},
	te: {
		core: "translation-te.json",
		hmdFeedback: "translation-te.json",
		homepage: "translation-te.json",
		learningModule: "translation-te.json",
		learningPathway: "translation-te.json",
		navigation: "translation-te.json",
		search: "translation-te.json",
		topic: "translation-te.json",
		webinar: "translation-te.json"
	},
	"te-IN": {
		core: "translation-te.json",
		hmdFeedback: "translation-te.json",
		homepage: "translation-te.json",
		learningModule: "translation-te.json",
		learningPathway: "translation-te.json",
		navigation: "translation-te.json",
		search: "translation-te.json",
		topic: "translation-te.json",
		webinar: "translation-te.json"
	},
	th: {
		core: "translation-th.json",
		hmdFeedback: "translation-th.json",
		homepage: "translation-th.json",
		learningModule: "translation-th.json",
		learningPathway: "translation-th.json",
		navigation: "translation-th.json",
		search: "translation-th.json",
		topic: "translation-th.json",
		webinar: "translation-th.json"
	},
	"th-TH": {
		core: "translation-th.json",
		hmdFeedback: "translation-th.json",
		homepage: "translation-th.json",
		learningModule: "translation-th.json",
		learningPathway: "translation-th.json",
		navigation: "translation-th.json",
		search: "translation-th.json",
		topic: "translation-th.json",
		webinar: "translation-th.json"
	},
	tr: {
		core: "translation-tr.json",
		hmdFeedback: "translation-tr.json",
		homepage: "translation-tr.json",
		learningModule: "translation-tr.json",
		learningPathway: "translation-tr.json",
		navigation: "translation-tr.json",
		search: "translation-tr.json",
		topic: "translation-tr.json",
		webinar: "translation-tr.json"
	},
	"tr-TR": {
		core: "translation-tr.json",
		hmdFeedback: "translation-tr.json",
		homepage: "translation-tr.json",
		learningModule: "translation-tr.json",
		learningPathway: "translation-tr.json",
		navigation: "translation-tr.json",
		search: "translation-tr.json",
		topic: "translation-tr.json",
		webinar: "translation-tr.json"
	},
	und: {
		core: "translation.json",
		credential: "translation.json",
		hmdFeedback: "translation.json",
		homepage: "translation.json",
		learningModule: "translation.json",
		learningPathway: "translation.json",
		navigation: "translation.json",
		search: "translation.json",
		topic: "translation.json",
		webinar: "translation.json"
	},
	vi: {
		core: "translation-vi.json",
		hmdFeedback: "translation-vi.json",
		homepage: "translation-vi.json",
		learningModule: "translation-vi.json",
		learningPathway: "translation-vi.json",
		navigation: "translation-vi.json",
		search: "translation-vi.json",
		topic: "translation-vi.json",
		webinar: "translation-vi.json"
	},
	"vi-VN": {
		core: "translation-vi.json",
		hmdFeedback: "translation-vi.json",
		homepage: "translation-vi.json",
		learningModule: "translation-vi.json",
		learningPathway: "translation-vi.json",
		navigation: "translation-vi.json",
		search: "translation-vi.json",
		topic: "translation-vi.json",
		webinar: "translation-vi.json"
	},
	zh: {
		core: "translation-zh.json",
		hmdFeedback: "translation-zh.json",
		homepage: "translation-zh.json",
		learningModule: "translation-zh.json",
		learningPathway: "translation-zh.json",
		navigation: "translation-zh.json",
		search: "translation-zh.json",
		topic: "translation-zh.json",
		webinar: "translation-zh.json"
	},
	"zh-CN": {
		core: "translation-zh.json",
		hmdFeedback: "translation-zh.json",
		homepage: "translation-zh.json",
		learningModule: "translation-zh.json",
		learningPathway: "translation-zh.json",
		navigation: "translation-zh.json",
		search: "translation-zh.json",
		topic: "translation-zh.json",
		webinar: "translation-zh.json"
	},
	"zh-TW": {
		core: "translation-zh.json",
		hmdFeedback: "translation-zh.json",
		homepage: "translation-zh.json",
		learningModule: "translation-zh.json",
		learningPathway: "translation-zh.json",
		navigation: "translation-zh.json",
		search: "translation-zh.json",
		topic: "translation-zh.json",
		webinar: "translation-zh.json"
	}
};
var arbManifest = {
	endpointMap: endpointMap
};

export { arbManifest as default, endpointMap };
